import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
  Alert,
} from '@mui/material';
import {
  QuestionAnswer as FAQIcon,
  Schedule as RecentIcon,
  TextFields as TextIcon,
} from '@mui/icons-material';
import { useFAQStats } from '../hooks/useFAQApi';

export const FAQStats: React.FC = () => {
  const { data: stats, isLoading, error } = useFAQStats();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error">
        Erreur lors du chargement des statistiques: {error.message}
      </Alert>
    );
  }

  if (!stats) {
    return (
      <Typography variant="body2" color="text.secondary" align="center">
        Aucune statistique disponible
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Statistiques FAQ
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FAQIcon color="primary" sx={{ mr: 2, fontSize: 40 }} />
                <Box>
                  <Typography variant="h4" component="div">
                    {stats.total_faqs}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total FAQs
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <RecentIcon color="secondary" sx={{ mr: 2, fontSize: 40 }} />
                <Box>
                  <Typography variant="h4" component="div">
                    {stats.recent_faqs}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Cette semaine
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <TextIcon color="info" sx={{ mr: 2, fontSize: 40 }} />
                <Box>
                  <Typography variant="h4" component="div">
                    {Math.round(stats.avg_answer_length)}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Mots/réponse
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
